import { useState } from 'react';
import { Envelope, ArrowRight, CheckCircle, ArrowLeft, ShieldWarning } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function Forgot2FAPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const r = await fetch(`${API}/api/auth/forgot-2fa`, {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email.trim().toLowerCase(),
          frontend_origin: window.location.origin,
        }),
      });
      if (!r.ok) {
        const d = await r.json().catch(() => ({}));
        throw new Error(d.detail || 'Aanvraag mislukt');
      }
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-4">
      <div className="w-full max-w-sm bg-white border border-zinc-200 rounded-sm p-8" data-testid="forgot-2fa-page">
        <a href="/login" className="inline-flex items-center gap-1 text-xs text-zinc-500 hover:text-zinc-900 mb-4">
          <ArrowLeft size={12} /> Terug naar login
        </a>
        <h1 className="font-heading text-2xl font-black tracking-tight mb-1">Authenticator vergeten</h1>
        <p className="text-sm text-zinc-500 mb-4">
          Geen toegang meer tot je authenticator-app? Vul je emailadres in. We sturen een reset-link (60 min geldig).
        </p>
        <div className="flex items-start gap-2 text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-sm p-2 mb-4">
          <ShieldWarning size={14} className="flex-shrink-0 mt-0.5" weight="fill" />
          <span>Na de reset moet je opnieuw enrollen via een nieuwe QR-code bij je volgende login.</span>
        </div>

        {sent ? (
          <div className="space-y-4 text-center" data-testid="forgot-2fa-success">
            <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mx-auto">
              <CheckCircle size={28} className="text-emerald-600" weight="fill" />
            </div>
            <div className="text-sm text-zinc-700">
              Als <strong>{email}</strong> bestaat, is er een 2FA-resetlink verstuurd.
              <br />Check je inbox (ook spam).
            </div>
            <a href="/login" className="inline-block px-4 py-2 text-sm bg-zinc-900 text-white rounded-sm hover:bg-zinc-800">
              Terug naar login
            </a>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <div className="relative">
              <Envelope size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
              <input
                type="email" placeholder="Emailadres" value={email}
                onChange={e => setEmail(e.target.value)} required autoFocus
                className="w-full pl-9 pr-4 py-2.5 text-sm border border-zinc-200 rounded-sm focus:outline-none focus:border-zinc-400"
                data-testid="forgot-2fa-email-input"
              />
            </div>
            {error && <div className="text-xs text-red-600">{error}</div>}
            <button
              type="submit" disabled={loading || !email}
              className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-[#0F172A] text-white text-sm font-medium rounded-sm hover:bg-[#1E293B] disabled:opacity-50"
              data-testid="forgot-2fa-submit-btn"
            >
              {loading ? 'Bezig...' : 'Stuur reset-link'}
              <ArrowRight size={14} />
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
